// CategoryApiService.js
import BaseInternalApiService from './BaseInternalApiService';
import axios from 'axios';

class CategoryApiService extends BaseInternalApiService {
  /**
   * Get all categories (admin only)
   */
  getCategories = async ({ page = 1, limit = 10, search = "", sort = "-createdAt" } = {}) => {
    try {
      const response = await this.getAxiosInstance().get('/categories', {
        params: {
          page,
          limit,
          search,
          sort,
        },
      });
      // Trả về cả categories và pagination
      return {
        categories: response.data?.data?.categories || [],
        pagination: response.data?.data?.pagination || {},
      };
    } catch (error) {
      console.error('Error getting categories:', error);
      throw error;
    }
  };

  /**
   * Get category by ID(admin only)
   */
  getCategoryById = async (categoryId) => {
    try {
      const response = await this.getAxiosInstance().get(`/categories/${categoryId}`);
      return response.data;
    } catch (error) {
      console.error(`Error getting category ${categoryId}:`, error);
      throw error;
    }
  };

  /**
   * Create a new category (admin only)
   */
  createCategory = async (category) => {
    try {
      const response = await this.getAxiosInstance().post('/categories', category);
      return response.data;
    } catch (error) {
      console.error('Error creating category:', error);
      throw error;
    }
  };

  /**
   * Update a category (admin only)
   */
  updateCategory = async (categoryId, category) => {
    try {
      const response = await this.getAxiosInstance().put(`/categories/${categoryId}`, category);
      return response.data;
    } catch (error) {
      console.error(`Error updating category ${categoryId}:`, error);
      throw error;
    }
  };

  /**
   * Delete a category (admin only)
   */
  deleteCategory = async (categoryId) => {
    try {
      const response = await this.getAxiosInstance().delete(`/categories/${categoryId}`);
      return response.data;
    } catch (error) {
      console.error(`Error deleting category ${categoryId}:`, error);
      throw error;
    }
  };

  /**
   * Assign category to users (admin only)
   * @param {String} categoryId Category ID
   * @param {Object} data Object containing userIds array
   * @returns {Promise} Promise that resolves when users are assigned
   */
  assignCategory = async (categoryId, data) => {
    try {
      const response = await this.getAxiosInstance().post(
        `/categories/${categoryId}/assign`,
        data
      );
      return response.data;
    } catch (error) {
      console.error(`Error assigning category to users:`, error);
      throw error;
    }
  };

  /**
   * Get Assignable users (admin only)
   */
  assignableUsers = async ({ page = 1, limit = 10, search = "", role } = {}) => {
    try {
      // Chỉ thêm role vào params nếu nó được truyền vào và không rỗng
      const params = { page, limit, search };
      if (role) {
        params.role = role;
      }

      const response = await this.getAxiosInstance().get(`/users/assignable`, {
        params
      });
      return response.data;
    } catch (error) {
      console.error(`Error getting assignable users:`, error);
      throw error;
    }
  };

  /**
   * Unassign users from category (admin only)
   * @param {String} categoryId Category ID
   * @param {Object} data Object containing userIds array
   * @returns {Promise} Promise that resolves when users are unassigned
   */
  unassignCategory = async (categoryId, data) => {
    try {
      const response = await this.getAxiosInstance().post(
        `/categories/${categoryId}/unassign`,
        data
      );
      return response.data;
    } catch (error) {
      console.error(`Error unassigning users from category:`, error);
      throw error;
    }
  };
}

export default new CategoryApiService();